import { createContext, useContext } from 'react';
import { WORKSPACE_VAZIO, type EstadoDoWorkspace } from './estado';

/**
 * O que a moldura empresta às telas de dentro.
 *
 * A moldura é uma rota de layout: ela monta uma vez e sobrevive à navegação.
 * Quem troca é só o centro. Como o estado do workspace passou a morar nela, a
 * tela de trabalho precisa de um caminho para ler e mudar esse estado sem
 * receber uma dúzia de props por uma rota que nem conhece props.
 */
export interface Workspace {
  estado: EstadoDoWorkspace;
  /** Muda o estado e leva a URL junto. */
  ir: (proximo: EstadoDoWorkspace) => void;
  /** Abre um arquivo numa aba e acende o explorador. */
  abrirArquivo: (caminho: string) => void;
}

const Contexto = createContext<Workspace>({
  estado: WORKSPACE_VAZIO,
  ir: () => {},
  abrirArquivo: () => {},
});

export const ProvedorDoWorkspace = Contexto.Provider;

export function usarWorkspace(): Workspace {
  return useContext(Contexto);
}
